import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * **Profitroom**
 *
 * @exports bs_268
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const isGoodersonDrakensbergResort = thn.data.propertyId === 1031876;
    const langReloader = () => {
        thn.languageCheck();
    };
    /**
        *
        * @memberOf module:bs_268
        *
        */
    engine._roomDetailsParseData = function roomDetailsParseData(adults, children) {
        const roomElArray = [...document.querySelectorAll('.availability-listing .common-primary-main')];
        if (thn.empty(roomElArray)) {
            return {};
        }
        const roomsInfo = roomElArray
            .map((room) => {
            const roomName = room.querySelector('.item-content__name > span')?.textContent;
            const roomType = getRoomType(roomName);
            const roomRates = [...room.querySelectorAll(':scope > div:first-child')]
                .map((rate) => {
                const price = thn.parseNumber(rate.querySelector('.price--total')?.textContent);
                const breakfast = !roomName.match(/ap?part|Апартаменты/i);
                const infoRate = {
                    id: '',
                    totalNight: price,
                    breakfast: breakfast,
                    refundable: true,
                };
                return infoRate;
            });
            return {
                id: '',
                name: roomName,
                adults: adults || 2,
                children: children || 0,
                type: roomType,
                prices: roomRates,
            };
        }).filter(Boolean);
        return roomsInfo;
    };
    const iframeLangReloader = () => {
        thn.languageCheck().then(function ({ changed }) {
            // Reload do not look necessary in iframe
            if (!changed) {
                thn.pageCheck();
            }
        });
    };
    /**
        *
       * @memberOf module:bs_268
       * @see {@link allowed_location}
       *
       * @param {object} ctx - The context object.
       */
    engine.allowedLocation = function allowedLocation(ctx) {
        // block execution on suite.profitroom.com
        if (window.location.hostname.includes('suite.profitroom')) {
            return false;
        }
        return true;
    };
    /**
       * @memberOf module:bs_268
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const accountToObserveOnBoot = [
            1037296,
            1037305,
            1039656, // Gooderson
            1039881, // Tikitam Palms Boutique Hotel
            1037735, // Crystal Suites
            1040743, // Your stay bristol
            1040929, // Finn Lough Forrest Hideaway
            1041983, // Welcome Break UK
            1041462, // Grosvenor
            1042146, // Airport Hotel Okecie
            1041777, // Grand Matlali
            1037195, // Sura Hotels
            1042775, // Norweska Dolina Hotels
            1042158, // Forest Hotel
            1042925, // Havet Hotel
            1035306, // Croc's
            1043269, // Belmonte Hotel Krynica Zdrój
            1043343, // Lemon Resort Spa
            1042973, // Grano Hotels
            1043983, // Kaiserhof Kitzbühel
            1040163, // Sun International
            1042325, // Hotel Wyspianski
            1044219, // Balthazar Design Hotel
            1044953, // Hotel Arlamow
            1044868, // Grand Ascot Hotel
            1045051, // Wozna 11 Aparthouse
            1045050, // Gwiazda Morza Resort & Spa
            1044739, // Peermont Hotels
            1045115, // Czorsztyn Prestige Apartments
            1045178, // HP Park Plaza
            1045200, // Arche Dwor Uphagena
            1045212, // Hotel Stok
            1045267, // Hotel Mlyn Jacka
            1044713, // Dunkeld Country Estate
            1045426, // Hotel Sadova
            1045439, // Vislow Resort
            1045354, // Q hotels
            1045360, // Europeum hotel
            1045464, // Brownsover Hall Hotel
            1045549, // Ascot Premium Hotel
            1041474, // African Regent Hotel
            1045444, // Nosalowy Hotels
            1045506, // Queen Boutique Hotel
            1045432, // Ardoe House Hotel & Grosvenor Glasgow Hotel
            1034442, // Parkhotel Adler
            1046496, // Grand Lubicz - Uzdrowisko Ustka
            1040743, // Your Stay Bristol
            1039321, // The Inn Jersey
            1046411, // Pod Cyprysami,Ustronie Park,Ruciane Park
            1046746, // Hotel Kotarz
            1047294, // Halcyon Mawella
            1047206, // Amber Design Residence
            1054926, // Palac i folwark lochow
            1047226, // Gough Hotels
            1047607, // Gasthaus & Hotel Drei Lilien
            1047710, // Destigo hotels
            1047921, // Hotel Monopol + Luzern AG
        ];
        // We take into consideration the hostname because the propertyId will match inside & outside the booking iframe
        const hostToObserveLanguageOutsideIframe = [
            'www.foresthotel.pl', // pid: 1036827
            'www.dwor.pl', // pid: 1036823
        ];
        if (accountToObserveOnBoot.includes(thn.data.accountUserId)) {
            const htmlElement = document.documentElement;
            thn.iframeObserver = thn.debounce(thn.pageCheck, 400);
            thn.observeDom(htmlElement, thn.iframeObserver, {
                childList: true,
                subtree: false,
                attributes: true,
                attributeFilter: ['tabindex', 'style'],
            });
            if (hostToObserveLanguageOutsideIframe.includes(window.location.hostname)) {
                thn.observeDom(htmlElement, langReloader, {
                    childList: false,
                    subtree: false,
                    attributes: true,
                    attributeFilter: ['lang'],
                });
            }
            thn.shutdown(function () {
                thn.stopObserveDom(htmlElement, thn.iframeObserver);
                delete thn.iframeObserver;
            });
        }
        // observe offers filter change for the property 1038772 (Belmonte Hotel Krynica Zdrój)
        const offersFilter = document.querySelector('.filters-offers');
        if (offersFilter && thn.data.propertyId === 1038772) {
            const refreshPage = thn.debounce(thn.pageCheck, 800);
            thn.observeDom(offersFilter, refreshPage, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPage.cancel();
                thn.stopObserveDom(offersFilter, refreshPage);
            });
        }
        const iframeContainerDialog = document.querySelector('#dialog94 .eb-content-wrap, .toolbar__content');
        if (iframeContainerDialog) {
            const refreshPageByContainerIframe = thn.debounce(() => {
                const isLoaderVisible = thn.isVisible(document.querySelector('.common-spinner'));
                if (!isLoaderVisible) {
                    thn.pageCheck();
                }
            }, 800);
            thn.observeDom(iframeContainerDialog, refreshPageByContainerIframe, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            thn.shutdown(() => {
                refreshPageByContainerIframe.cancel();
                thn.stopObserveDom(iframeContainerDialog, refreshPageByContainerIframe);
            });
        }
    };
    /**
     * @memberOf module:bs_268
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new URL(ctx.baseUrl);
        const validUrl = url.hostname.match(/booking.profitroom/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        url.pathname = url.pathname.replace(/\/([a-z]{2})\//i, `/${thn.data.language}/`);
        url.searchParams.set('check-in', '[date_begin]');
        url.searchParams.set('check-out', '[date_end]');
        // multiple room search
        // https://booking.profitroom.com/en/dobranocwoznaaparthouse/pricelist/multiroom/rooms?check-in=2024-09-11&check-out=2024-09-12&currency=PLN&r1_adults=1&r2_adults=1&r2_child0-10=1&wh_token=4a718dd3-533c-4949-a76c-9af7e2c921ac-208106-pms&code=travel
        if (ctx.data.roomsDispo?.length > 1) {
            url.pathname = url.pathname.replace(/\/(rooms|offers)(\/.*)?$/, '/multiroom/rooms');
        }
        else {
            url.pathname = url.pathname.replace(/\/(rooms|offers)(\/.*)?$/, '/rooms');
        }
        for (const key of [...url.searchParams.keys()]) {
            if (key.includes('child') || key.includes('adult')) {
                url.searchParams.delete(key);
            }
        }
        ctx.data.roomsDispo?.forEach((room, index) => {
            url.searchParams.set(`r${index + 1}_adults`, `${room.adults}`);
            if (room.children > 0) {
                // r2_child0-10=1
                url.searchParams.set(`r${index + 1}_child0-10`, `${room.children}`);
            }
        });
        ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
        ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
       * @memberOf module:bs_268
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = thn.isVisible(document.querySelector('.btn-myaccount')) || !!document.querySelector('.js-login__client-panel.is-visible');
        return isLogged;
    };
    /**
       * @memberOf module:bs_268
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        const langDictionary = {
            français: 'fr',
            polski: 'pl',
            english: 'en',
            deutsch: 'de',
            italiano: 'it',
            español: 'es',
        };
        return new Promise(function (resolve, reject) {
            const lang = ((document.querySelector('.wpml-ls-flag') || {}).alt || '')
                || ((window.location.pathname.match('^/?/[a-z]{2}/') || [])[0] || '').replace(/[/]/g, '')
                || thn.dataLayerHelper.get('language');
            let langFormatted = lang && lang.length > 2 ? langDictionary[lang.toLowerCase()] : lang;
            if (langFormatted === 'cz') {
                langFormatted = 'cs';
            }
            if (langFormatted && ctx.langs.test(langFormatted)) {
                if ([1048013].includes(thn.data.propertyId) && lang === 'se') {
                    langFormatted = 'sv';
                }
                resolve(langFormatted);
                return;
            }
            reject('no_language');
        });
    };
    /**
       * @memberOf module:bs_268
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(() => {
            const formerCurrency = thn.widgets.price.data.currency;
            const currentCurrency = thn.parseUrlParameter('currency'); // The "currency" parameter in the URL takes a few milliseconds to change.
            if (formerCurrency !== currentCurrency && thn.widgets.price.isTargetPage()) {
                if (thn.widgets.price.refresh() && !thn.widgets.price.isSet()) {
                    thn.widgets.price.hide();
                }
            }
        }, 600);
        // Reload lang
        setTimeout(() => {
            iframeLangReloader();
        }, 800);
    };
    /**
       * @memberOf module:bs_268
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const container = document.querySelector('.main-container');
        const isForcePageCheckUsers = [1044219, 1044953, 1044868, 1045051, 1045050, 1045212, 1045266, 1045267, 1045354, 1045178, 1045426, 1045360, 1045444, 1043343, 1039321, 1047226];
        if (container && !thn.ProfitroomObserver) {
            thn.ProfitroomObserver = thn.debounce(() => {
                const isLoaderVisible = thn.isVisible(document.querySelector('.common-spinner'));
                ctx.widget.hide();
                if (!isLoaderVisible) {
                    if (isForcePageCheckUsers.includes(thn.data.accountUserId)) {
                        thn.pageCheck({ force: true });
                    }
                    else {
                        ctx.widget.refresh();
                    }
                }
            }, 800);
            thn.observeDom(container, thn.ProfitroomObserver, {
                childList: true,
                subtree: false,
                attributes: false,
                characterData: true,
            });
            thn.pageUnload(() => {
                thn.ProfitroomObserver.cancel();
                thn.stopObserveDom(container, thn.ProfitroomObserver);
                delete thn.ProfitroomObserver;
            });
        }
    };
    /**
       * @memberOf module:bs_268
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        const dateBegin = thn.parseUrlParameter('check-in') || thn.dataLayerHelper.get('dateCheckIn') || '';
        const dateEnd = thn.parseUrlParameter('check-out') || thn.dataLayerHelper.get('dateCheckOut') || '';
        widgetData.dateBegin = dateBegin.replace(/-/g, '/');
        widgetData.dateEnd = dateEnd.replace(/-/g, '/');
        let nights;
        if (widgetData.dateBegin && widgetData.dateEnd) {
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Guests, Adults & Children
        widgetData.roomsDispo = [];
        const roomsQty = thn.dataLayerHelper.get('num_of_rooms');
        const roomInfo = {
            adults: 0,
            childrenAges: [],
        };
        for (let i = 0; i < roomsQty; i += 1) {
            let roomAdults = thn.parseNumber(thn.parseUrlParameter(`r${i + 1}_adults`))
                || thn.parseNumber((document.querySelector('[add-attribute="occupancy-picker-add-adult"] [class*=wrapper__count]') || {}).textContent) || 2;
            let roomChildren = thn.parseNumber(thn.parseUrlParameter(`r${i + 1}_child4-11`), 10) || 0;
            let roomBabies = thn.parseNumber(thn.parseUrlParameter(`r${i + 1}_child0-3`), 10) || 0;
            if (document.querySelector('.occupancy-picker-child-container')) {
                // Reset number of children
                roomChildren = 0;
                roomBabies = 0;
                // occupancy-picker-child-container is a component that contains a age range and the number of children within that range
                const ageRanges = [...document.querySelectorAll('.occupancy-picker-child-container')].map((el) => {
                    // Get max and min age or the range thorugh a match
                    const ages = ((el.querySelector('span') || {}).textContent || '').match(/(\d+)/g);
                    // Get older age
                    const maxAge = ages && ages.length > 1 && thn.parseNumber(ages[1]);
                    // Parse the number of children within that age range
                    const numberChildren = thn.parseNumber((el.querySelector('[class*=wrapper__count]') || {}).textContent);
                    // Filter out undefined values
                    // if number_children is 0 will be false, for that reason, we need to check if number_children is not 0 and is undefined
                    if (!maxAge || (!numberChildren && numberChildren !== 0)) {
                        return false;
                    }
                    return {
                        age: maxAge,
                        numberChildren: numberChildren,
                    };
                }).filter(Boolean);
                ageRanges.forEach((ageRange) => {
                    if (ageRange.age <= 4) {
                        roomBabies += ageRange.numberChildren;
                    }
                    else {
                        roomChildren += ageRange.numberChildren;
                    }
                });
            }
            roomAdults += roomInfo.adults;
            roomInfo.adults = roomAdults;
            roomInfo.childrenAges = [];
            for (let j = 1; j <= roomChildren; j += 1) {
                roomInfo.childrenAges.push(11);
            }
            for (let k = 1; k <= roomBabies; k += 1) {
                roomInfo.childrenAges.push(3);
            }
        }
        widgetData.roomsDispo.push(roomInfo);
        // Prices & Currency || No Rooms
        const loyaltyPriceSelector = '.loyalty-price-container__price';
        const propertyUsingLoyaltyPrice = [1046135].includes(thn.data.propertyId) && document.querySelector(loyaltyPriceSelector);
        const discountPricesSelector = '.price-strike-container.price--rate-type .price';
        const usersUsingDiscountPrices = [1045178].includes(thn.data.accountUserId) && document.querySelector(discountPricesSelector);
        const currency = thn.parseUrlParameter('currency') || thn.dataLayerHelper.get('currency');
        const roomsElement = document.querySelectorAll('.availability-listing .card.common-item, .card.common-item');
        const rooms = isGoodersonDrakensbergResort ? [...roomsElement].filter((roomEl) => !roomEl.querySelector('.item-content__name')?.textContent?.includes('Caravan')) : [...roomsElement];
        let pricesSelector = '.price--total, .loyalty-original-price--bold';
        if (propertyUsingLoyaltyPrice) {
            pricesSelector = loyaltyPriceSelector;
        }
        if (usersUsingDiscountPrices) {
            pricesSelector = discountPricesSelector;
        }
        const prices = [...rooms].map((room) => !room.querySelector('.item-content__name span')?.textContent?.match(/ap?part|Апартаменты/i) && thn.parseNumber(room.querySelector(pricesSelector)?.textContent)).filter(Boolean);
        const noAvailability = !!document.querySelector('.availability-container .booking-engine-alert');
        const isPriceSpecial = !!window.location.pathname.match(/pricelist\/offers\/\d+\//);
        if (isPriceSpecial) {
            widgetData.priceSpecial = 1;
        }
        if (currency?.length && prices.length && nights) {
            widgetData.price = ((Math.min(...prices) / nights) * 100) / 100;
            widgetData.currency = currency;
            widgetData.roomDetails = engine._roomDetailsParseData(widgetData.adults, widgetData.children);
            widgetData.set = true;
        }
        else if (noAvailability) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
     * @memberOf module:bs_268
     * @this thn.widgets.price
     * @see {@link Price#getPromocode}
     *
     * @param {object} ctx - The context object.
     */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = thn.parseUrlParameter('codes');
        if (promocode) {
            return promocode;
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_268
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        // Booking_id
        const bookingId = thn.dataLayerHelper.get('bookingReference') || thn.dataLayerHelper.get('booking_reference') || document.querySelector('.ref-value')?.textContent || document.querySelector('.booking-reference__code')?.textContent;
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        // Dates
        const dateBegin = thn.dataLayerHelper.get('date_check_in') || thn.dataLayerHelper.get('checkIn');
        const dateEnd = thn.dataLayerHelper.get('date_check_out') || thn.dataLayerHelper.get('checkOut');
        widgetData.dateBegin = dateBegin?.replace(/-/g, '/');
        widgetData.dateEnd = dateEnd?.replace(/-/g, '/');
        // Price && Currency
        const price = thn.dataLayerHelper.get('price_total') || document.querySelector('.priceValue')?.textContent || document.querySelector('[data-cy=payment-rooms] .payment-item-value')?.textContent;
        const currency = document.querySelector('.priceCurrency')?.textContent || document.querySelector('.payment-item-value')?.textContent;
        widgetData.price = thn.parseNumber(price) || parseFloat(thn.dataLayerHelper.get('priceTotal')) || thn.parseNumber(thn.dataLayerHelper.get('value'));
        widgetData.currency = thn.parseCurrency(currency) || thn.dataLayerHelper.get('currency') || thn.dataLayerHelper.get('base_currency');
        // Guests
        const adults = thn.dataLayerHelper.get('num_of_adults');
        const children = thn.dataLayerHelper.get('num_of_children');
        widgetData.adults = thn.parseNumber(adults);
        widgetData.children = thn.parseNumber(children);
        widgetData.guests = widgetData.adults + widgetData.children;
        if ([1045836, 1033780].includes(thn.data.propertyId) && window.location.pathname.match(/step2byreference/)) {
            thn.logger.debug('dataLayer', window.dataLayer);
            thn.uploadPageHtml();
            thn.uploadReport();
        }
        return widgetData;
    };
    return engine;
}

export { factory };
